import React, { useEffect, useState } from "react";
import { FormattedMessage,  useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { AxiosResponse } from "axios";

import Seo from "../../../common/helpers/seo";
import Experience from "../../components/Experience";
import ExperienceEditor from "../../pages/plan/ExperienceEditor";

import { amazonHost, experienceChristmasPath, experienceEasterPath } from "../../paths";

import { P2, StyledArticle, H2, H3, P1, H4 as H4Theme } from "../styles";

import messages from "./messages";
import { IPlan } from "../../../common/types";
import { get } from "../../actions/general";
import { IStateTree } from "../../store/interfaces";

import { StyledSpring, Container, Screen, CreateFlex, CreateLeft, CreatePadding, CreateRight, H4, StyledHello, Ribbon, EditHello, TippCard, TippContainer, StyledThemes, Theme, ThemeImage, NewMarker } from "./styles";
import image from "./image";
import FormattedHtmlMessage from "../../../common/helpers/FormattedHtmlMessage";

const experiencePlanId = "601d6da6b838fe001e0fe799";


const ExperienceArticle = () => {
    const { formatMessage, locale } = useIntl();
    const dispatch = useDispatch();
    const webp = useSelector(({ webp }: IStateTree) => webp);
    const [experiencePlan, setExperiencePlan] = useState<null | IPlan>(null);

    useEffect(() => {
        dispatch(get(`public-plan?planId=${experiencePlanId}&anonymous=false`, (res: AxiosResponse) => {
            setExperiencePlan(res.data.plan);
        }));
    }, []);

    const smartboardBackground = "url(" + amazonHost + `landing/smartboard.${webp ? "webp" : "png"})`;
    return (
        <StyledSpring withShadow marginTop={50}>
            <StyledArticle light>
                <Seo
                    title={formatMessage(messages.title)}
                    type={"article"}
                    image={image}
                    description={formatMessage(messages.description)}
                />
                <Container
                    style={{
                        backgroundImage: smartboardBackground,
                    }}
                >
                    <Screen>
                        {experiencePlan && (
                            <Experience
                                plan={experiencePlan}
                                setReset={() => null}
                                saveState={() => null}
                                restoreState={() => null}
                                showSolution={() => null}
                                completed={() => null}
                                setTaskIndex={() => null}
                                isSimulation
                            />
                        )}
                    </Screen>
                </Container>
                <StyledHello>
                    <H2>
                        <FormattedMessage {...messages.title} />
                    </H2>
                    <P1 center>
                        <FormattedMessage {...messages.description} />
                    </P1>
                </StyledHello>
            </StyledArticle>
            <Ribbon />
            <StyledArticle dark>
                <EditHello>
                    <H3 info>
                        <FormattedMessage {...messages.featuresTitle} />
                    </H3>
                    <P2 dark center>
                        <FormattedMessage {...messages.featuresDescription} />
                    </P2>
                </EditHello>
                <CreatePadding>
                    <CreateFlex>
                        <CreateLeft>
                            <H4><FormattedMessage {...messages.features1Title} /></H4>
                            <P2 dark><FormattedMessage {...messages.features1Description} /></P2>
                            <H4><FormattedMessage {...messages.features2Title} /></H4>
                            <P2 dark><FormattedMessage {...messages.features2Description} /></P2>
                        </CreateLeft>
                        <CreateRight>
                            {experiencePlan && (
                                <ExperienceEditor plan={experiencePlan} publicView={false} isSimulation />
                            )}
                        </CreateRight>
                    </CreateFlex>
                    <H4 className="NoMarginTop"><FormattedMessage {...messages.features3Title} /></H4>
                    <P2 dark><FormattedMessage {...messages.features3Description1} /></P2>
                    <P2 dark><FormattedMessage {...messages.features3Description2} /></P2>
                    <P2 dark><FormattedMessage {...messages.features3Description3} /></P2>
                    <H4><FormattedMessage {...messages.features4Title} /></H4>
                    <P2 dark><FormattedMessage {...messages.features4Description} /></P2>
                </CreatePadding>
            </StyledArticle>
            <Ribbon />
            <StyledArticle light>
                <H3>
                    <FormattedMessage {...messages.themes} />
                </H3>
                <StyledThemes>
                    <div>
                        <Theme style={{ backgroundImage: smartboardBackground }}>
                            <ThemeImage src={`${experienceEasterPath}/experience-theme-basic.jpg`} />
                        </Theme>
                        <H4Theme center style={{ marginTop: 0 }}>
                            <FormattedMessage {...messages.basic} />
                        </H4Theme>
                    </div>
                    <div>
                        <Theme style={{ backgroundImage: smartboardBackground }}>
                            <ThemeImage src={`${experienceChristmasPath}/experience-theme-christmas${locale === "hu" ? "" : "-en"}.jpg`} />
                            {/* <NewMarker>
                                <FormattedMessage {...messages.newTheme} />
                            </NewMarker> */}
                        </Theme>
                        <H4Theme center style={{ marginTop: 0 }}>
                            <FormattedMessage {...messages.christmasTuning} />
                        </H4Theme>
                    </div>
                    <div>
                        <Theme style={{ backgroundImage: smartboardBackground }}>
                            <ThemeImage src={`${experienceEasterPath}/experience-theme-easter${locale === "hu" ? "" : "-en"}.jpg`} />
                        </Theme>
                        <H4Theme center style={{ marginTop: 0 }}>
                            <FormattedMessage {...messages.easter} />
                        </H4Theme>
                    </div>
                </StyledThemes>
            </StyledArticle>
            <Ribbon />
            <TippContainer>
                <StyledArticle>
                    <H3 info><FormattedMessage {...messages.tipTitle} /></H3>
                    <TippCard>
                        <ul>
                            <li><FormattedMessage {...messages.tip1} /></li>
                            <li><FormattedMessage {...messages.tip2} /></li>
                            <li><FormattedMessage {...messages.tip3} /></li>
                            <li><FormattedHtmlMessage {...messages.tip4} /></li>
                        </ul>
                    </TippCard>
                </StyledArticle>
            </TippContainer>
        </StyledSpring>
    );
}

export default ExperienceArticle;
